import React, { useState, useEffect } from 'react';
import { Form, Row, Col, InputGroup, Button, Badge, Card, Modal } from 'react-bootstrap';
// external
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ClipLoader from 'react-spinners/ClipLoader';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import { ColorInput } from 'react-rainbow-components';
import SelectFile from 'components/form-elements/SelectFile';
import ButtonRequest from 'components/buttons/ButtonRequest';

// utils
import { handlerErrors, handleAPIError, handleCatchError } from 'utils/handleErrors';
import TrackingStatuses from './TrackingStatuses';
import TrackingChannels from './TrackingChannels';

// api
import { updateExternalNotifications } from '../../../../api/Api-user';

const ExternalNotifications = ({ configData, setTrigger }) => {
  const isActive = configData.user_profile.destination_notifications_enabled;
  const [selectedState, setSelectedState] = useState(configData.user_profile.destination_notification_statuses);
  const [selectedChannels, setSelectedChannels] = useState(configData.user_profile.destination_channels);
  const [companyName, setCompanyName] = useState(configData.user_profile.email_company_name);
  const [logoFile, setLogoFile] = useState({ img: null });
  // configData.user_profile.email_company_logo
  const [color, setColor] = useState({ hex: configData.user_profile.email_company_color, alpha: 1, isValid: true });
  const [isConfNotifications, setIsConfNotifications] = useState(false);
  const [isDeleteNotifications, setIsDeleteNotifications] = useState(false);
  const [isModalToggleOpen, setIsModalToggleOpen] = useState(false);

  // console.log('configData:', configData);
  // console.log('external status selected: ', selectedState);
  const handleToggleNotifications = async () => {
    setIsConfNotifications(true);
    try {
      const response = await updateExternalNotifications({
        isActive: true,
        selectedState,
        selectedChannels,
        logoFile,
        color,
        companyName,
      });
      // console.log(response);
      if (response.success !== undefined) {
        setTrigger((prev) => !prev);
        toast.success(response.message, {
          position: 'top-right',
          autoClose: true,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'dark',
        });
      } else if (response.error) {
        handleAPIError(response);
      }
    } catch (error) {
      handlerErrors(error);
    } finally {
      setIsConfNotifications(false);
    }
  };
  const handlerDeactivateNotifications = async () => {
    try {
      setIsConfNotifications(true);
      const response = await updateExternalNotifications({
        isActive: false,
        selectedState,
        selectedChannels,
        logoFile,
        // color: '#007bff',
        color,
        companyName,
      });
      // console.log('eliminar notificaciones externas:', response);
      if (response.message !== undefined) {
        toast.success(response.message, {
          position: 'top-right',
          autoClose: true,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'dark',
        });
        setTrigger((prev) => !prev);
        setIsDeleteNotifications(true);
      } else if (response.error) {
        handleAPIError(response);
        setIsDeleteNotifications(false);
      }
    } catch (error) {
      handlerErrors(error);
      setIsDeleteNotifications(false);
    } finally {
      setIsConfNotifications(false);
    }
  };

  return (
    <>
      <Modal
        show={isModalToggleOpen}
        onHide={() => {
          setIsDeleteNotifications(false);
          setIsModalToggleOpen(false);
        }}
      >
        <Modal.Header closeButton>
          {/* <Modal.Title className="text-primary">
            <div className="text-primary"> </div>{' '}
          </Modal.Title> */}
        </Modal.Header>
        <Modal.Body className="bg-infow">
          <div className="text-semi-large mb-4">
            ¿Confirmas que deseas <strong>desactivar</strong> la notificaciones externas?
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex flex-wrap justify-content-end bg-warningd">
            <Button
              variant="outline-primary"
              style={{ height: '36px' }}
              className="w-auto me-2 mb-2"
              onClick={() => {
                setIsDeleteNotifications(false);
                setIsModalToggleOpen(false);
              }}
            >
              Cancelar
            </Button>
            <Button
              variant="primary"
              size="xl"
              // className="mx-2"
              className="py-0"
              onClick={handlerDeactivateNotifications}
              style={{ height: '36px' }}
            >
              {isConfNotifications && <ClipLoader disabled={isConfNotifications} color="#FFFFFF" loading={isConfNotifications} size={10} />}
              {isConfNotifications ? 'Si, continuar' : 'Si, continuar'}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Row>
        <Col xl="8" className="order-2 order-xl-1">
          <h2 className="small-title invisible">Configuración</h2>
          <Card>
            <Card.Body>
              <h1 className="display-4">{isActive ? 'Editar notificaciones para tus clientes' : 'Activar notificaciones para tus clientes'}</h1>
              <div className="mt-2">
                {isActive ? (
                  'Las notificaciones para tus clientes están activas. Puedes modificar la configuración en cualquier momento.'
                ) : (
                  <>
                    Configura esta opción para <strong>enviar</strong> automáticamente reportes de seguimiento a tus clientes. Se utilizará el correo registrado
                    en la dirección de destino.
                  </>
                )}
              </div>
              <Form>
                <Row className="pt-5">
                  <Col xs="12" xl="8" className="mb-3">
                    <Form.Label>1. Nombre de tu empresa o negocio</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <CsLineIcons icon="home" size="16" className="text-alternate" />
                      </InputGroup.Text>
                      <Form.Control
                        required
                        type="text"
                        value={companyName}
                        onChange={(e) => {
                          setCompanyName(e.target.value);
                        }}
                      />
                    </InputGroup>
                    <Form.Text>Este nombre aparecerá como remitente en las notificaciones que se envíen a tus clientes.</Form.Text>
                  </Col>
                  <Col xs="12" xl="8" className="position-relative mb-3 bg-secondaryx">
                    <Form.Label>2. Logo de la empresa</Form.Label>
                    <SelectFile
                      //   isRequired
                      placeholder="Arrastra o selecciona tu imagen aquí"
                      //  helpText="(mas info detallada)"
                      formObj={setLogoFile}
                      fieldName="img"
                      // setErrors={setErrors}
                    />
                    <Form.Text> Este logo se mostrará en las notificaciones por correo enviadas a tus clientes.</Form.Text>
                    {/* <div className={`invalid-tooltip ${errors.frontINE ? 'd-block' : 'd-none'}`}>{errors.frontINE}</div> */}
                  </Col>
                  <Col xs="12" xl="8" className="mb-3">
                    <Form.Label>3. Elige el color que identifica a tu empresa</Form.Label>
                    {/* <div style={{ maxWidth: 325 }}> </div> */}
                    <ColorInput value={color} onChange={setColor} borderRadius="semi-rounded" size="small" style={{ maxWidth: 325, overflow: 'hidden' }} />
                    <Form.Text>Tus notificaciones usarán este color como parte de la identidad visual de tu marca</Form.Text>
                  </Col>
                  <Col xs="12" className="mb-3">
                    <TrackingStatuses
                      statuses={configData.available_notification_statuses.tracking_statuses}
                      selectedState={selectedState}
                      setSelectedState={setSelectedState}
                    />
                  </Col>
                  <Col xs="12" className="mb-3">
                    <TrackingChannels
                      channels={configData.available_notification_statuses.destination_channels}
                      selectedChannels={selectedChannels}
                      setSelectedChannels={setSelectedChannels}
                    />
                  </Col>
                  <Col xs="12" className="my-5">
                    <ButtonRequest
                      title={isActive ? 'Actualizar configuración' : 'Guardar y activar'}
                      titleLoading={isActive ? 'Editando' : 'Activar'}
                      handlerFn={handleToggleNotifications}
                      isButtonDisabled={isConfNotifications}
                      isLoading={isConfNotifications}
                    />
                  </Col>
                </Row>
              </Form>
            </Card.Body>
          </Card>
        </Col>
        <Col xl="4" className="order-1 order-xl-2">
          <h2 className=" small-title">Estado</h2>
          <Card className="mb-3">
            <Card.Body>
              <div>
                <div className="cta-4 mb-2">Notificaciones Externas:</div>
                <Badge bg={isActive ? 'success' : 'danger'} className="text-uppercase fw-bolder" style={{ fontSize: '12px' }}>
                  <span>{isActive ? 'Activas' : 'Inacivas'}</span>
                </Badge>
                {isActive && (
                  <div className="bg-warningx d-flex my-3">
                    <span className="me-1 d-flex aling-items-end bg-infox">¿Deseas desactivar estas notificaciones?</span>
                    <Form.Check
                      type="switch"
                      //  id="switch_insurance"
                      className="bg-successx d-flex aling-items-end"
                      checked={isDeleteNotifications}
                      onChange={() => {
                        setIsDeleteNotifications(!isDeleteNotifications);
                        setIsModalToggleOpen(true);
                      }}
                    />
                  </div>
                )}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ExternalNotifications;
